import Drawer from 'rsuite/Drawer';
import styles from './BaseDrawer.module.scss';

const BaseDrawer = (props) => {
	const {
		open,
		onClose,
		header,
		renderBtns = () => {},
		children,
		placement = 'right',
		style = {},
		size = 'lg',
		bodyStyle = {},
		className = '',
		color = '',
	} = props;

	return (
		<Drawer
			size={size}
			style={style}
			placement={placement}
			open={open}
			enforceFocus={false}
			onClose={onClose}
			className={`${styles.root} ${color ? styles[color] : ''} ${className}`}
		>
			<Drawer.Header className='items-center'>
				<Drawer.Title>{header}</Drawer.Title>
				<Drawer.Actions>{renderBtns()}</Drawer.Actions>
			</Drawer.Header>
			<Drawer.Body
				style={bodyStyle || {}}
				className={styles.body}
			>
				{children}
			</Drawer.Body>
		</Drawer>
	);
};

export default BaseDrawer;
